export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'

export const USER_FETCH = 'USER_FETCH'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_FAILURE = 'USER_FAILURE'
export const USER_UPDATE = 'USER_UPDATE'

export const TYPE_FETCH = 'TYPE_FETCH'
export const TYPE_SUCCESS = 'TYPE_SUCCESS'
export const TYPE_FAILURE = 'TYPE_FAILURE'
export const TYPE_UPDATE = 'TYPE_UPDATE'

export const TYPE_FETCH_ADMIN = 'TYPE_FETCH_ADMIN'
export const TYPE_SUCCESS_ADMIN = 'TYPE_SUCCESS_ADMIN'
export const TYPE_FAILURE_ADMIN = 'TYPE_FAILURE_ADMIN'
export const TYPE_UPDATE_ADMIN = 'TYPE_UPDATE_ADMIN'
export const TYPE_UPDATEALL_ADMIN = 'TYPE_UPDATEALL_ADMIN'

export const PREFIX_FETCH_START = 'PREFIX_FETCH_START'
export const PREFIX_FETCH_END = 'PREFIX_FETCH_END'